// Detect whether breeze is running inside an iframe (e.g. the my-anythink wrapper).
// Used to fork flows that can't run inside an iframe — notably external OAuth pages
// which set X-Frame-Options: DENY and refuse to render embedded.
export const isInWrapper = (): boolean => {
  try {
    return window.parent !== window;
  } catch {
    // Cross-origin parent — access threw, which itself means we're framed.
    return true;
  }
};
